export default "__VITE_ASSET__DvQYEhUy__"